import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

import { getLikes } from './utils/requests';

export const usePrefetchFileLikes = ({
  fileId,
  userId,
  queryKey,
  railsType,
  showReactions = true,
}) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (fileId && railsType && showReactions) {
      queryClient.prefetchQuery(
        [queryKey, fileId],
        () => getLikes({ fileId, userId, railsType }),
        {
          staleTime: Infinity,
        },
      );
    }
  }, [fileId, showReactions]);
};
